import { HttpEventType } from '@angular/common/http';
import { Component, Optional } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { TypeDocumentEnums } from 'src/app/enum/type-document-enums';
import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ClientImportModel } from 'src/app/models/imports/client-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ClientService } from 'src/app/services/archive/client.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-client',
  templateUrl: './import-client.component.html',
  styleUrls: ['./import-client.component.scss'],
  standalone: false
})
export class ImportClientComponent {

  clientAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  clientImport: boolean = false;
  eventFile: any
  errorClient: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  visibleTxt: boolean = false;

  constructor(private clientService: ClientService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.clientImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  downloadGuideImport() {
    this.clientService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response:
          {
            const downloadedFile = new Blob([data.body!], { type: data.body!.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = "GuiaClientes.docx";
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
          }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.clientAlerts || this.clientAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.clientService.exportImportErrors(this.clientAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionClientes_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  importClients() {
    this.clientAlerts = [];
    this.errorClient = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<ClientImportModel>();
    let row: ClientImportModel;
    let counter: number = 1, typeDocumentId: number, documentNumber: string, digitVerification: number, documentNumber2: string, digitVerification2: number, typePersonId: number,
      names: string | null, lastNames: string | null, businessName: string, comercialName: string, address: string, email: string | null,
      taxEmail: string | null, phone: string, alterPhone: string | null, departmentCode: string, cityCode: string,
      swExpirationDays: boolean, expirationDays: number, swIvaRetainer: boolean, swIvaResponsible: boolean, swDeclarant: boolean,
      swGreatContributor: boolean, swSimpleTaxRegime: boolean, clientStateId: number, observation: string;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      this.clientAlerts = [];
      this.visibleTxt = false;

      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          "El archivo ingresado no tiene registros para importar."
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter = counter + 1;
        let rowHasError = false;

        //A. Tipo de Documento:
        if (element[0] as string != "N" && element[0] as string != "C" && element[0] as string != "E" && element[0] as string != 'P' && element[0] as string != 'T') {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El tipo de documento debe ser valores como: 'N' / 'C' / 'E' / 'P' / 'T'.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        switch (element[0] as string) {
          case "N": {
            typeDocumentId = TypeDocumentEnums.nit;
            break;
          }
          case "C": {
            typeDocumentId = TypeDocumentEnums.cedula;
            break;
          }
          case "E": {
            typeDocumentId = TypeDocumentEnums.extranjeria;
            break;
          }
          case "P": {
            typeDocumentId = TypeDocumentEnums.ppt;
            break;
          }
          default: {
            typeDocumentId = TypeDocumentEnums.ti;
            break;
          }
        }

        //B. Documento:
        documentNumber = element[1] as string;
        if (documentNumber == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El documento no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        } else {
          if (documentNumber == '0') {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El documento '0' no es válido.`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
          if (documentNumber.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El documento supera el tamaño máximo de caracteres (15).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        //C. Dígito de verificación:
        digitVerification = parseFloat(element[2] as string);

        if (isNaN(digitVerification) || digitVerification < 0 || digitVerification > 9) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El dígito de verificación no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        //D. Documento2:
        documentNumber2 = element[3] as string;
        if (documentNumber2 != null) {
          if (documentNumber2 == "0") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El documento2 '0' no es válido.`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }

          if (documentNumber2.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El documento2 supera el tamaño máximo de caracteres (15).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        //E. Dígito de verificación2:
        digitVerification2 = parseFloat(element[4] as string);
        if (!isNaN(digitVerification2)) {
          if (digitVerification2 < 0 || digitVerification2 > 9) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. El dígito de verificación 2 no es válido.`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        //F. Tipo de Persona:
        if (element[5] as string != "N" && element[5] as string != "J") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El tipo de persona debe ser valores como: N / J.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        typePersonId = element[5] as string === "N" ? TypePersonEnums.natural : TypePersonEnums.juridica;
        if (typePersonId == TypePersonEnums.juridica && typeDocumentId == TypeDocumentEnums.cedula) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El cliente tiene definido como Tipo Persona: JURÍDICA, el Tipo de Documento NO puede ser Ced.Ciudadanía.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        //G. Nombres, h. Apellidos y I. Razón Social:
        if (typePersonId == TypePersonEnums.natural) {
          names = element[6] as string;
          lastNames = element[7] as string;
          if (names == null || lastNames == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G-H. Los nombres o apellidos del cliente no es válido.`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          } else if (names.length > 75 || lastNames.length > 75) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G-H. Los nombres o apellidos superan el tamaño máximo de caracteres (75).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
          businessName = `${names} ${lastNames}`;
        } else {
          names = null;
          lastNames = null;
          businessName = element[8] as string;
          if (businessName == null) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. La razón social del cliente no es válido.`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          } else if (businessName.length > 150) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. La razón social supera el limite máximo de caracteres (150).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        //J. Nombre Comercial:
        comercialName = element[9] as string;
        if (comercialName != null) {
          if (comercialName.length > 100) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna J. El nombre comercial supera el tamaño máximo de caracteres (100).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        //K. Teléfono:
        phone = element[10] as string;
        if (isNaN(parseFloat(phone))) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. El teléfono del cliente no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        } else if (phone.length < 7 || phone.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. El teléfono del cliente no tiene una longitud válida.(7-15).`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        //L. Teléfono alterno
        alterPhone = element[11] as string;
        if (alterPhone != null) {
          if (alterPhone.length < 7 || alterPhone.length > 15) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna L. El teléfono alterno del cliente no tiene una longitud válida.(7-15).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        // M. E-mail:
        email = element[12] as string;
        if (email != null && email.length > 250) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. El correo electrónico supera el tamaño máximo de caracteres (250).`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        // N. E-mail Fiscal:
        taxEmail = element[13] as string;
        if (taxEmail != null && taxEmail.length > 250) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna N. El correo electrónico fiscal supera el tamaño máximo de caracteres (250).`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        // O. Dirección:
        address = element[14] as string;
        if (address == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna O. La dirección del cliente no es válida.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        } else if (address.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna O. La dirección del cliente supera el tamaño máximo de caracteres (70).`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        // P. Ciudad:
        cityCode = element[15] as string;
        if (cityCode == null || cityCode.length > 3) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna P. El código de la ciudad no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        // Q. Departamento:
        departmentCode = element[16] as string;
        if (departmentCode == null || departmentCode.length > 2) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Q. El código del departamento no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        // R. Días Vencimiento:
        expirationDays = element[17] as string != null ? parseFloat(element[17] as string) : 0;
        if (isNaN(expirationDays)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna R. El campo días de vencimiento no es válido.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swExpirationDays = expirationDays != 0;

        // S. Declarante:
        if (element[18] as string != "S" && element[18] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna S. El campo declarante debe ser valores como: S / N.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swDeclarant = element[18] as string === "S" ? true : false;

        // T. Regimén Simple de Tributación:
        if (element[19] as string != "S" && element[19] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna T. El campo regimén simple de tributación debe ser valores como: S / N.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swSimpleTaxRegime = element[19] as string === "S" ? true : false;

        // U. Responsable de Iva:
        if (element[20] as string != "S" && element[20] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna U. El campo responsable de IVA debe ser valores como: S / N.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swIvaResponsible = element[20] as string === "S" ? true : false;

        // V. Gran Contribuyente:
        if (element[21] as string != "S" && element[21] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna V. El campo gran contribuyente debe ser valores como: S / N.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swGreatContributor = element[21] as string === "S" ? true : false;

        // W. Retenedor Iva:
        if (element[22] as string != "S" && element[22] as string != "N") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna W. El campo retenedor de IVA debe ser valores como: S / N.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        swIvaRetainer = element[22] as string === "S" ? true : false;

        //Válido Sws:
        if (swSimpleTaxRegime && (swGreatContributor || swIvaRetainer)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. Si el cliente es Regimén Simple de Tributación, no puede ser Gran Contribuyente ni Retenedor de Iva.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        if ((swGreatContributor || swIvaRetainer) && !swIvaResponsible) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}. Si el cliente es Gran Contribuyente y/o Retenedor de Iva, debe ser Responsable de Iva.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }

        //X. Estado:
        if (element[23] as string != "A" && element[23] as string != "S" && element[23] as string != "I") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna X. El estado debe ser valores como: 'A' / 'S' / 'I'.`;
          this.clientAlerts.push(alert);
          rowHasError = true;
        }
        switch (element[23] as string) {
          case "A": {
            clientStateId = ClientStateEnums.activo;
            break;
          }
          case "S": {
            clientStateId = ClientStateEnums.suspendido;
            break;
          }
          default: {
            clientStateId = ClientStateEnums.inactivo;
            break;
          }
        }

        //Z. Observación:
        observation = element[24] as string;
        if (observation != null) {
          if (observation.length > 1000) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna Z. La observación supera el tamaño máximo de caracteres (1000).`;
            this.clientAlerts.push(alert);
            rowHasError = true;
          }
        }

        if (!rowHasError) {
          row = new ClientImportModel(counter, typeDocumentId, documentNumber, digitVerification, documentNumber2, digitVerification2, typePersonId, names, lastNames, businessName,
            comercialName, address, email, taxEmail, phone, alterPhone, departmentCode, cityCode, swExpirationDays, expirationDays, swIvaRetainer,
            swIvaResponsible, swDeclarant, swGreatContributor, swSimpleTaxRegime, clientStateId, observation);
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorClient = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        this.clearInputFile();
        return;
      }

      await this.processImportFamilies(rowsImports);
    });
  }

  async processImportFamilies(rowsImports: Array<ClientImportModel>) {
    try {
      const response = await firstValueFrom(this.clientService.importClients(rowsImports));
      this.loadPreInvoicingModel = response;
      this.clientAlerts = response?.alerts ?? [];
      this.errorClient = response?.preInvoicingStateId;

      if (this.errorClient === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea.',
          'ERROR'
        );
      } else if (this.clientAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.clientImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close()
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar Clientes.', error);
    }
  }
}